export const ArrayAggregationModeOptions = {
  ADD_ALL: 'add_all',
  ADD_FIRST_NON_BLANK: 'add_first_non_blank',
} as const;

export const ARRAY_SEPARATORS = {
  comma: 'comma',
  newline: 'newline',
} as const;
